module.exports = __webpack_public_path__ + "img/selected0-min.8ecc5255.png";